<template>
  <div>
    <b-modal
      ref="matterCustomsRegistrationRenewalFormModal"
      id="matterCustomsRegistrationRenewalFormModal"
      centered
      size="lg"
      no-close-on-backdrop
      :title="$t('matter.matter_customs_registration_renewal')"
      :cancel-title="$t('others.cancel_title')"
      :ok-title="$t('others.ok_title')"
      cancel-variant="outline-secondary"
      @ok.prevent="addOrUpdate()"
    >
        <b-card>
            <b-row>
                <b-col class="col-lg-4">
                    <b-form>
                        <label style=" white-space: nowrap;">{{ $t('lawMatterCustomsRegistrationRenewal.renewal_reminder_date') }}</label>
                        <b-form-group>
                            <b-form-datepicker today-button :label-today-button="$t('dateTime.today')" size="sm" v-model="renewalReminderDate" class="mb1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-4">
                    <b-form>
                        <label>{{ $t('lawMatterCustomsRegistrationRenewal.reminder_response_date') }}</label>
                        <b-form-group>
                            <b-form-datepicker today-button :label-today-button="$t('dateTime.today')" size="sm" v-model="reminderResponseDate" class="mb1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-4">
                    <label>{{ $t('lawMatterCustomsRegistrationRenewal.is_renewal_instruction') }}</label>
                    <b-form-checkbox class="custom-control-success" v-model="isRenewalInstruction" switch>
                        <span class="switch-icon-left">
                            <feather-icon icon="CheckIcon" />
                        </span>
                        <span class="switch-icon-right">
                            <feather-icon icon="XIcon" />
                        </span>
                    </b-form-checkbox>
                </b-col>  
            </b-row>
            <b-row>
                <b-col class="col-lg-4">
                    <b-form>
                        <label>{{ $t('lawMatterCustomsRegistrationRenewal.renewal_application_date') }}</label>
                        <b-form-group>
                            <b-form-datepicker today-button :label-today-button="$t('dateTime.today')" size="sm" v-model="renewalApplicationDate" class="mb1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-4">
                    <b-form>
                        <label>{{ $t('lawMatterCustomsRegistrationRenewal.application_no') }}</label>
                        <b-form-group>
                            <b-form-input size="sm" v-model="applicationNo" maxlength="50" />
                        </b-form-group>
                    </b-form>
                </b-col>
                 <b-col class="col-lg-4">
                    <b-form>
                        <label>{{ $t('lawMatterCustomsRegistrationRenewal.response_served_date') }}</label>
                        <b-form-group>
                            <b-form-datepicker today-button :label-today-button="$t('dateTime.today')" size="sm" v-model="responseServedDate" class="mb1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
                        </b-form-group>
                    </b-form>
                </b-col>
            </b-row>
             <b-row>
                 <b-col class="col-lg-4">
                        <b-form>
                            <label>{{ $t('lawMatterCustomsRegistrationRenewal.conclusion') }}</label>
                            <b-form-group>
                                <b-form-select  size="sm" v-model="lawMatterConclusionSelect" value-field="id" text-field="name" :options="lawMatterConclusionOptions" />
                            </b-form-group>
                        </b-form>
                </b-col>
                <b-col class="col-lg-4">
                    <b-form>
                        <label>{{ $t('lawMatterCustomsRegistrationRenewal.next_renewal_date') }}</label>
                        <b-form-group>
                            <b-form-datepicker today-button :label-today-button="$t('dateTime.today')" size="sm" v-model="nextRenewalDate" class="mb1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
                        </b-form-group>
                    </b-form>
                </b-col>
            </b-row>
        </b-card>
    </b-modal>
  </div>
</template>

<script>
export default {
    data(){
        return {
            id:0,
            reminderResponseDate: null,
            renewalReminderDate: null,
            renewalApplicationDate: null,
            responseServedDate :null,
            nextRenewalDate :null,
            applicationNo: '',
            isRenewalInstruction: false,
            lawMatterConclusionOptions: [],
            lawMatterConclusionSelect: 0
        }
    },
    methods:{
        async showInfo(id){
            this.$refs['matterCustomsRegistrationRenewalFormModal'].show()
            this.id = id
            const data = {  id: this.id}
              
            const controller = {  name: 'LawMatterCustomsRegistrationRenewal' }
            const payload = { data: data,controller: controller}

            const response = await this.$store.dispatch('moduleAuth/getInfo', payload)
                if (response.data.resultStatus == true) {
                    this.lawMatterConclusionOptions = response.data.lawMatterConclusionList
                    this.lawMatterConclusionOptions.splice(0, 0, this.$nullSelected())
                    this.lawMatterConclusionSelect = response.data.lawMatterCustomsRegistrationRenewal.lawMatterConclusionId

                    this.reminderResponseDate =response.data.lawMatterCustomsRegistrationRenewal.reminderResponseDate
                    this.renewalReminderDate =response.data.lawMatterCustomsRegistrationRenewal.renewalReminderDate
                    this.renewalApplicationDate =response.data.lawMatterCustomsRegistrationRenewal.renewalApplicationDate
                    this.responseServedDate =response.data.lawMatterCustomsRegistrationRenewal.responseServedDate
                    this.nextRenewalDate=response.data.lawMatterCustomsRegistrationRenewal.nextRenewalDate
                    this.applicationNo =response.data.lawMatterCustomsRegistrationRenewal.applicationNo
                    this.isRenewalInstruction =response.data.lawMatterCustomsRegistrationRenewal.isRenewalInstruction
                   
                } else {
                    this.$bvModal.hide('matterCustomsRegistrationRenewalFormModal')
                    this.$WarningAlert(response.data.resultMessage)
                }
          
        },
        async addOrUpdate(){
            const lawMatterCustomsRegistrationRenewalData = {
                id: this.id,
                lawMatterCustomsRegistrationId: this.lawMatterCustomsRegistrationId,
                lawMatterConclusionId: this.lawMatterConclusionSelect,
                reminderResponseDate :this.reminderResponseDate,
                renewalReminderDate: this.renewalReminderDate,
                renewalApplicationDate: this.renewalApplicationDate,
                nextRenewalDate :this.nextRenewalDate,
                responseServedDate: this.responseServedDate,
                applicationNo: this.applicationNo,
                isRenewalInstruction: this.isRenewalInstruction
            };
             const controller = {name: 'LawMatterCustomsRegistrationRenewal' }   
             const payload = {data: lawMatterCustomsRegistrationRenewalData,  controller: controller}
             const response = await this.$store.dispatch('moduleAuth/save', payload)
                if (response.data.resultStatus) {
                    this.$bvModal.hide('matterCustomsRegistrationRenewalFormModal')
                    this.getMatterCustomsRegistrationRenewalList()
                    this.$SaveAlert()
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }   
        }
    },
    props: {
        lawMatterCustomsRegistrationId :{
             type: Number
        },
        getMatterCustomsRegistrationRenewalList:{
            type: Function
        }
    }
}

</script>

<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    background-color: #ea5455 !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}
</style>